module.exports = {"id":"181132","name":"Zé Eduardo","rating":"73","photo":"./data/images/photos/1/181132.png","club":{"name":"Al Faisaly","logo":"./data/images/clubs/AlFaisaly.png"},"positions":["BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ZeEduardo0.json
// module id = 4464
// module chunks = 0